module.exports = __webpack_public_path__ + "static/media/stacked_chart.927623c8.svg";